module.exports = "https://web-assets-production.autolist.com/_next/static/images/albany-ny-7277576d286b94649d6a0b448deaecd3.jpg";